import React from 'react'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import NiceModal from '@ebay/nice-modal-react'
import DeliverAllTasksModal from './components/DeliverAllTasksModal'
import { useIntl } from 'react-intl'
import messages from './messages'

const DeliverAllTasks = ({ order, refetch, readOnly }) => {
  const { formatMessage } = useIntl()
  
  const onClick = () => {
    NiceModal.show(DeliverAllTasksModal, {order: order})
        .then(refetch())
        .catch((error) => {
          toastr.error(error)
        })
  }

  return (
    <Menu.Item key='deliverAllTasks' disabled={readOnly}>
      {(props) => (
        <MenuButton disabled={readOnly} {...props} onClick={onClick}>
          { formatMessage(messages.title) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default DeliverAllTasks
